exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{position:relative;display:block}mat-form-field{width:100%}input{padding-left:10px;padding-right:40px}input.hasSearchIcon{padding-right:80px}.searchButtonDiv{position:absolute;right:0;top:0}.searchButtonDiv>button:nth-child(2):before{content:\"\";position:absolute;left:0;top:5px;border-right:1px solid #ddd;height:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/search/search-bar/search-bar.component.styl
// module id = 1089
// module chunks = 0